module.exports = __webpack_public_path__ + "img/wibo-06.56236c64.jpg";